import { useCallback, useState } from "react";
import type { WidgetState } from "../types";

/**
 * Hook for managing widget state machine
 */
export function useWidgetState(initialState: WidgetState = "idle") {
  const [state, setState] = useState<WidgetState>(initialState);

  const setWidgetState = useCallback((newState: WidgetState) => {
    setState((prevState) => {
      if (prevState === newState) return prevState;
      console.log(`State: ${prevState} -> ${newState}`);
      return newState;
    });
  }, []);

  return {
    state,
    setState: setWidgetState,
    isIdle: state === "idle",
    isLoading: state === "loading",
    isActive: state === "active",
    isListening: state === "listening",
    isSpeaking: state === "speaking",
    isProcessing: state === "processing",
    isError: state === "error",
  };
}
